import type { InternalCookieOptions } from './types';
import { getExpiresInMonths, setCookie } from './utils';

const COOKIE_NAME = 'stby';

/** Sets the `stby` (birth year) cookie. */
export const writeBirthYearCookie = (
  birthYear: number,
  options: InternalCookieOptions,
): void => {
  setCookie(COOKIE_NAME, String(birthYear), options, getExpiresInMonths(1));
};
